/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import ComplexTextInput from '../ComplexTextInput';
import PickerModal from './PickerModal';
import { ModalManagerContext } from '../../../ModalsManager';

const DateAndTime = ({
  id,
  value,
  dateTitle,
  timeTitle,
  setFieldValue,
  setFieldTouched,
  grayBackground,
  disabled,
  error,
}) => {
  const openModal = useContext(ModalManagerContext);
  const classes = useStyles();
  const dateId = `${id}-date`;
  const timeId = `${id}-time`;

  const pickDateAndTime = () => {
    openModal(
      PickerModal,
      newValue => new Promise(resolve => {
        setFieldValue(id, newValue);
        setFieldTouched(id, true, false);
        return resolve();
      }),
      value,
      classes.modal,
    );
  };

  const commonProps = {
    type: 'text',
    grayBackground,
    onClick: pickDateAndTime,
    onKeyPress: pickDateAndTime,
    altClasses: { container: classes.inputContainer },
    disabled,
  };

  return (
    <div
      className={classes.container}
      onClick={pickDateAndTime}
      onKeyPress={pickDateAndTime}
      role="button"
      tabIndex={0}
    >
      <ComplexTextInput
        id={dateId}
        title={dateTitle}
        value={value.date}
        iconName="calendar"
        error={error}
        {...commonProps}
      />
      <ComplexTextInput
        id={timeId}
        title={timeTitle}
        value={value.time}
        iconName="clock"
        error={error}
        {...commonProps}
      />
    </div>
  );
};


DateAndTime.defaultProps = {
  grayBackground: true,
  dateTitle: '',
  timeTitle: '',
  disabled: false,
};

DateAndTime.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.shape({
    time: PropTypes.string,
    date: PropTypes.string,
  }).isRequired,
  dateTitle: PropTypes.string,
  timeTitle: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  grayBackground: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool.isRequired,
};

export default DateAndTime;
